import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { CareType } from '../higherEd';
import { CurrentUser } from '../../resources';
import { SubSystem } from '@uplift/types';
import { PsychiatryOnlyUtmSource } from '../onboarding';


export type PatientDetails = {
  userId: string;
  autopayEnabled: boolean;
  zocdoc: boolean;
  nonpaymentDeactivationEnabled: boolean;
  onboardingCaretypeSelection: CareType;
  onboardingRecommendedCaretype: CareType;
};

export const getPatientDetails = async (patientId: string) => restClient.request<{
  data: PatientDetails;
}>(`/api/v1/patient/${patientId}/details`);

export type UpdatePatientDetailsInput = Partial<{
  onboardingCaretypeSelection: CareType | null;
  onboardingRecommendedCaretype: CareType | null;
}>;

export const updatePatientDetails = (patientId: string, details: UpdatePatientDetailsInput) => restClient.request(`/api/v1/patient/${patientId}/details`, {
  method: 'PATCH',
  data: snakecaseKeys(details),
});


export const checkIsPsychiatryOnlyUser = (me: CurrentUser, utmSource?: PsychiatryOnlyUtmSource) => {
  return !!utmSource || me.subsystem === SubSystem.betterhelp;
};
